import { Upload } from 'lucide-react';
import { useRef } from 'react';
import { studioApi, useStudioDocuments, useUploadStudioDocument } from '@/api/studio';
import { DownloadButton } from '@/components/DownloadButton';
import { QueryPending } from '@/components/QueryState';
import { formatSize, formatWhen } from '@/lib/format';

/** The files of one client (or of one project of it), with the studio's upload; the client is told about a new file. */
export function StudioFiles({ clientId, projectId }: { clientId: string; projectId?: string }) {
  const docsQ = useStudioDocuments({ clientId, projectId });
  const upload = useUploadStudioDocument();
  const input = useRef<HTMLInputElement>(null);
  return (
    <section>
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-sm font-semibold">Файлы</h2>
        <input
          ref={input}
          type="file"
          className="hidden"
          aria-label="Выбрать файл"
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) upload.mutate({ clientId, projectId, file: f });
            e.target.value = '';
          }}
        />
        <button className="btn-secondary" onClick={() => input.current?.click()} disabled={upload.isPending}>
          <Upload className="size-4" /> {upload.isPending ? 'Загружаем…' : 'Загрузить файл'}
        </button>
      </div>
      {upload.error && (
        <p role="alert" className="mb-2 text-sm text-overdue">
          {(upload.error as Error).message}
        </p>
      )}
      {!docsQ.data ? (
        <QueryPending query={docsQ} compact />
      ) : docsQ.data.length === 0 ? (
        <p className="text-sm text-muted">Файлов нет. Загруженный вами файл клиент увидит в своих документах.</p>
      ) : (
        <ul className="divide-y divide-line border-y border-line">
          {docsQ.data.map((d) => (
            <li key={d.id} className="flex items-center gap-3 py-2.5 text-sm">
              <span className="min-w-0 flex-1 truncate">{d.name}</span>
              <span className="text-muted">
                {d.uploadedBy.name}, {formatWhen(d.uploadedAt)}, {formatSize(d.sizeKb)}
              </span>
              <DownloadButton load={() => studioApi.downloadDocument(d.id)} name={d.name} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
